import Header from '@/components/common/Header'
import UserNav from '@/components/user-settings/UserNav'
import { Grid, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { FC } from 'react'

interface ConfigHeaderProps {
  title: string
  subtitle: string
  hiddenUser?: boolean
}

const ConfigHeader: FC<ConfigHeaderProps> = ({
  title,
  subtitle,
  hiddenUser = false,
}) => {
  return (
    <Stack sx={{ height: '45px' }}>
      <Header
        left={
          <Box
            sx={{
              color: 'text.main',
              padding: '2px 2px',
              marginLeft: '15px',
              height: '32px',
            }}
          >
            <Stack
              direction="row"
              spacing="10px"
              sx={{ textDecoration: 'none' }}
            >
              <Box>
                <Grid>
                  <Typography
                    color="text.main"
                    sx={{
                      lineHeight: '14px',
                      fontSize: '13px',
                      fontWeight: '400',
                    }}
                  >
                    {subtitle}
                  </Typography>
                </Grid>
                <Grid>
                  <Typography
                    sx={{
                      color: 'primary.main',
                      alignItems: 'center',
                      fontWeight: '600',
                      lineHeight: '14px',
                      fontSize: '15px',
                      mt: '2px',
                    }}
                  >
                    {title}
                  </Typography>
                </Grid>
              </Box>
            </Stack>
          </Box>
        }
        right={<UserNav />}
      />
    </Stack>
  )
}

export default ConfigHeader
